import React, {Fragment} from 'react';
import Box from '../layout/Box';
import {EditorField as Editor} from '../form/editor/editor';
import createEditor from '../form/ComponentEditor';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import EmailTemplateList from "./lists/EmailTemplateList";
import EmailTemplateForm from "./forms/EmailTemplateForm";

class EmailTemplateEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;

        const actionButtons = [];

        if (this.props.fieldForm === undefined || (this.props.fieldForm !== undefined && this.props.values[this.props.componentConfig.idfield])) {
            actionButtons.push(
                <Button
                    key="0"
                    disabled={!this.props.dirty || this.props.isLoading}
                    color="primary"
                    className="pull-right"
                    onClick={this.saveForm}
                >
                    Mentés
                </Button>
            );
        }

        if (this.props.fieldForm !== undefined && !this.props.values[this.props.componentConfig.idfield]) {
            return <Box header="Hiba" theme="danger">
                Kérd meg az IT-t hogy vegyék fel a(z) '{this.props.fieldForm}' email sablont!
            </Box>;
        }

        return (
            <Fragment>
                {this.props.fieldForm === undefined && <List
                    {...this.props}
                    theme="default"
                    header={"Email sablonok"}
                    footer={[
                        <Button
                            key="0"
                            disabled={this.props.isLoading}
                            color="default"
                            onClick={this.pristineForm}>
                            Új
                        </Button>
                    ]}
                >
                    <EmailTemplateList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>}
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Email sablon"
                    footer={actionButtons}
                >
                    <EmailTemplateForm {...this.props} filter={this.props.fieldForm !== undefined ? [{field: "token", value: this.props.fieldForm}] : null} />
                </Editor>
            </Fragment>
        );
    }
}

export default createEditor({componentName: "EmailTemplate", WrappedComponent: EmailTemplateEditor, props: {view: "admin"}});
